
module.exports = `
  with base_location as (
    select 
      fsid,
      uuid as location_id,
      orders_status,
      loan_limit
    from avocado.data_location 
    where uuid = $1
  ),
  has_60_90_day_options as (
    select 
      distinct po.location_id
    from base_location l
    inner join avocado.payment_plan_options po on po.location_id = l.location_id 
    where frequency in ('BIMONTHLY', 'TRIMONTHLY')
  )
  select
    l.location_id,
    l.fsid,
    l.orders_status,
    l.loan_limit,
    vt.total_balance as overall_balance,
    vt.due_balance as overdue_balance,
    case 
      when coalesce(o.location_id, '') != '' then true
      else false
    end as has_60_day_option,
    case 
      when coalesce(o.location_id, '') != '' then true
      else false
    end as has_90_day_option
  from base_location l
  left join avocado.get_quickbookstransactions_by_location(l.location_id) vt on l.location_id = vt.location_id
  left join has_60_90_day_options o on l.location_id = o.location_id
  limit 1
`
